import React from "react";
import type { ProjectStatus } from "../../state/workspaces/types";
import { Localized } from "../../strings";
import { hexToRgba } from "../../utils/hexToRgba";
import { hiconToHoyluUiIconsCentered } from "../../utils/icon.map";
import { Label } from "../label";
import Styles from "./ProjectSelectorLabel.module.css";
import { remainingDaysInProject } from "./remaining.days.in.project";

type ProjectSelectorLabelProps = {
  icon: string;
  name: string;
  status: ProjectStatus | null;
  color?: string;
  endDate?: string | null;
  hasAdmin: boolean;
};

export function ProjectSelectorLabel({
  icon,
  name,
  status,
  color,
  endDate,
  hasAdmin,
}: ProjectSelectorLabelProps) {
  const daysRemaining = remainingDaysInProject(endDate);
  const isProjectInactive = status === "Inactive";
  const colorVariant = isProjectInactive
    ? hexToRgba(color ?? "", 0.5, "#716C83")
    : color;

  return (
    <div className={Styles.projectSelector} title={name}>
      <div
        className={`${
          hiconToHoyluUiIconsCentered(icon) || "hoylu-ui-icons-box"
        } ${Styles.projectIcon}`}
        style={{ color: colorVariant }}
      />
      <div
        className={`${Styles.projectName} ${
          isProjectInactive ? Styles.inactive : ""
        }`}
      >
        {name}
      </div>
      {!!daysRemaining && hasAdmin && (
        <Label
          text={Localized.string("PROJECT.DURATION", daysRemaining)}
          title={Localized.string("PROJECT.REMAINING_DURATION", daysRemaining)}
        />
      )}
    </div>
  );
}
